module.exports = __webpack_public_path__ + "assets/img/picture1.da8a8f5a.png";